module.exports = __webpack_public_path__ + "static/media/02-register-banner-vc-170x170.78c1a0ed.jpg";